const worksData = [
    {
        src:"./alice_logo.jpg",
        genre:"ロゴ",
        order:"不思議の国のアリス杯",
        detail:"友人主催の囲碁大会のロゴを制作"
    },{
        src:"./alice_flyer.jpg",
        genre:"フライヤー",
        order:"不思議の国のアリス杯",
        detail:"友人主催囲碁大会のフライヤーを制作"
    },{
        src:"./poop_1.jpg",
        genre:"ゲーム画面",
        order:"蜻蛉会",
        detail:"友人グループとゲームを共同開発中"
    },{
        src:"./poop_2.jpg",
        genre:"ゲーム画面",
        order:"蜻蛉会",
        detail:"友人グループとゲームを共同開発中"
    },{
        src:"./toilet.mp4",
        genre:"ゲーム画面",
        order:"蜻蛉会",
        detail:"友人グループとゲームを共同開発中"
    }
];

export default worksData;